import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('token') || '',
    userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
    menus: JSON.parse(localStorage.getItem('menus') || '[]'),
    currentRole: JSON.parse(localStorage.getItem('currentRole') || 'null')
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
    },
    SET_MENUS(state, menus) {
      state.menus = menus
      localStorage.setItem('menus', JSON.stringify(menus))
    },
    SET_CURRENT_ROLE(state, role) {
      state.currentRole = role
      if (role) {
        localStorage.setItem('currentRole', JSON.stringify(role))
      } else {
        localStorage.removeItem('currentRole')
      }
    },
    LOGOUT(state) {
      state.token = ''
      state.userInfo = {}
      state.menus = []
      state.currentRole = null
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
      localStorage.removeItem('menus')
      localStorage.removeItem('currentRole')
    }
  },
  actions: {
    login({ commit }, { token, userInfo, menus }) {
      commit('SET_TOKEN', token)
      commit('SET_USER_INFO', userInfo)
      commit('SET_MENUS', menus)
    },
    setMenus({ commit }, menus) {
      commit('SET_MENUS', menus)
    },
    setCurrentRole({ commit }, role) {
      commit('SET_CURRENT_ROLE', role)
    },
    logout({ commit }) {
      commit('LOGOUT')
    }
  },
  getters: {
    isLoggedIn: state => !!state.token
  }
})
